import { render, staticRenderFns } from "./ExpedienteDigital.vue?vue&type=template&id=81416456&scoped=true"
import script from "./ExpedienteDigital.vue?vue&type=script&lang=js"
export * from "./ExpedienteDigital.vue?vue&type=script&lang=js"
import style0 from "./ExpedienteDigital.vue?vue&type=style&index=0&id=81416456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81416456",
  null
  
)

export default component.exports